export function isValidSocketEvent(event) {
    return !!event.type;
}
//# sourceMappingURL=events.js.map